import React, { useState } from 'react';
import { loginUser } from '../services/authService';
import '../styles/Login.css';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [firstLoginData, setFirstLoginData] = useState({
    email: '',
    name: '',
    tempPassword: '',
    password: '',
    inviteCode: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [forcePasswordChange, setForcePasswordChange] = useState(false);
  const [loginMode, setLoginMode] = useState('normal'); // 'normal', 'tutor-first', 'admin-first'
  const [emailVerified, setEmailVerified] = useState(false); // 이메일 인증 상태
  const [verifyingEmail, setVerifyingEmail] = useState(false); // 이메일 인증 중 상태

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleFirstLoginChange = (e) => {
    setFirstLoginData({
      ...firstLoginData,
      [e.target.name]: e.target.value
    });
  };

  // 이메일 인증 함수
  const handleEmailVerification = async () => {
    if (!firstLoginData.email.trim()) {
      setError('이메일을 입력해주세요.');
      return;
    }

    // 이메일 형식 검증
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(firstLoginData.email)) {
      setError('올바른 이메일 형식을 입력해주세요.');
      return;
    }

    setVerifyingEmail(true);
    setError('');

    try {
      // users 컬렉션에서 해당 이메일로 등록된 튜터가 있는지 확인
      const { getDocs, collection, query, where } = await import('firebase/firestore');
      const { db } = await import('../firebase');
      
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('email', '==', firstLoginData.email.toLowerCase()), where('role', '==', 'tutor'));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        throw new Error('등록되지 않은 이메일입니다. 관리자에게 문의하세요.');
      }
      
      // 이미 등록된 튜터 정보 가져오기
      const existingTutor = querySnapshot.docs[0].data();
      
      // 비밀번호가 이미 설정되어 있는지 확인
      if (existingTutor.password && existingTutor.password !== '') {
        throw new Error('이미 계정이 생성된 이메일입니다. 일반 로그인을 이용해주세요.');
      }
      
             // 이름만 자동 설정
       setFirstLoginData(prev => ({
         ...prev,
         name: existingTutor.name || ''
       }));
      
      setEmailVerified(true);
      setError('');
    } catch (error) {
      setError(error.message || '이메일 인증에 실패했습니다.');
      setEmailVerified(false);
    } finally {
      setVerifyingEmail(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
             // 최초 로그인 모드
      if (isFirstLogin) {
        // 관리자 최초 로그인인 경우 모든 필드 검증
        if (loginMode === 'admin-first') {
          if (!firstLoginData.email || !firstLoginData.name || !firstLoginData.password || !firstLoginData.inviteCode) {
            setError('모든 필드를 입력해주세요.');
            setLoading(false);
            return;
          }
        } else {
          // 튜터 최초 로그인인 경우 초대코드 제외하고 검증
          if (!firstLoginData.email || !firstLoginData.name || !firstLoginData.password) {
            setError('모든 필드를 입력해주세요.');
            setLoading(false);
            return;
          }
        }

        // 이메일 형식 검증
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(firstLoginData.email)) {
          setError('올바른 이메일 형식을 입력해주세요.');
          setLoading(false);
          return;
        }

        // 관리자 최초 로그인
        if (loginMode === 'admin-first') {
          if (!firstLoginData.email.endsWith('@elicer.com')) {
            setError('관리자는 elicer.com 도메인의 이메일만 사용 가능합니다.');
            setLoading(false);
            return;
          }

          // 초대코드 검증
          try {
            const { verifyInviteCode } = await import('../services/firestoreService');
            const isValidCode = await verifyInviteCode(firstLoginData.inviteCode);
            if (!isValidCode) {
              setError('유효하지 않은 초대코드입니다.');
              setLoading(false);
              return;
            }
          } catch (error) {
            setError('초대코드 검증에 실패했습니다.');
            setLoading(false);
            return;
          }

          // 관리자 계정 생성
          const adminData = {
            name: firstLoginData.name,
            email: firstLoginData.email.toLowerCase(),
            role: 'admin',
            password: firstLoginData.password,
            createdAt: new Date(),
            updatedAt: new Date()
          };

          console.log('🔧 관리자 계정 생성 시도:', adminData);

          // Firestore에 저장
          const { addDoc, collection, serverTimestamp } = await import('firebase/firestore');
          const { db } = await import('../firebase');
          
          const usersRef = collection(db, 'users');
          const docRef = await addDoc(usersRef, {
            ...adminData,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp()
          });

          console.log('✅ 관리자 계정 Firestore에 저장 완료. Document ID:', docRef.id);

          const userData = {
            id: docRef.id,
            ...adminData
          };

          console.log('👤 생성된 사용자 데이터:', userData);
          onLogin(userData);
          setLoading(false);
          return;
                         } else {
          // 튜터 최초 로그인 (임시 비밀번호 변경 포함)
          if (!emailVerified) {
            setError('이메일 인증을 먼저 완료해주세요.');
            setLoading(false);
            return;
          }
          
          try {
            const { getDocs, collection, query, where, updateDoc, doc, serverTimestamp, deleteField } = await import('firebase/firestore');
            const { db } = await import('../firebase');
            
            const usersRef = collection(db, 'users');
            const q = query(usersRef, where('email', '==', firstLoginData.email.toLowerCase()), where('role', '==', 'tutor'));
            const querySnapshot = await getDocs(q);
            
            if (querySnapshot.empty) {
              throw new Error('등록되지 않은 이메일입니다. 관리자에게 문의하세요.');
            }
            
            const existingTutor = querySnapshot.docs[0].data();
            const tutorRef = doc(db, 'users', querySnapshot.docs[0].id);

            if (forcePasswordChange) {
              // 임시비밀번호 검증
              if (existingTutor.tempPassword && existingTutor.tempPassword !== firstLoginData.tempPassword) {
                throw new Error('임시 비밀번호가 올바르지 않습니다.');
              }
              if (firstLoginData.tempPassword === firstLoginData.password) {
                throw new Error('임시 비밀번호와 동일한 비밀번호는 사용할 수 없습니다.');
              }
              await updateDoc(tutorRef, {
                password: firstLoginData.password,
                requiresPasswordChange: false,
                tempPassword: deleteField(),
                updatedAt: serverTimestamp()
              });
              const updatedUserData = {
                id: querySnapshot.docs[0].id,
                ...existingTutor,
                password: firstLoginData.password,
                requiresPasswordChange: false
              };
              onLogin(updatedUserData);
              setLoading(false);
              return;
            }
            
            // (과거) 일반 최초 로그인 경로
            if (existingTutor.password && existingTutor.password !== '') {
              throw new Error('이미 계정이 생성된 이메일입니다. 일반 로그인을 이용해주세요.');
            }
            await updateDoc(tutorRef, {
              name: firstLoginData.name,
              password: firstLoginData.password,
              updatedAt: serverTimestamp()
            });
            const updatedUserData = {
              id: querySnapshot.docs[0].id,
              ...existingTutor,
              name: firstLoginData.name,
              password: firstLoginData.password
            };
            onLogin(updatedUserData);
            setLoading(false);
            return;
          } catch (error) {
            setError(error.message || '계정 생성에 실패했습니다.');
            setLoading(false);
            return;
          }
        }
      }

      // 일반 로그인 (이메일)
      if (!formData.email || !formData.password) {
        setError('코더랜드 이메일과 비밀번호를 입력하세요.');
        setLoading(false);
        return;
      }

      // 실제 Firebase 인증
      const userData = await loginUser(formData.email, formData.password);
      
      // 튜터가 임시비밀번호로 로그인한 경우: 비밀번호 변경 플로우로 전환
      if (userData.role === 'tutor' && userData.requiresPasswordChange) {
        setIsFirstLogin(true);
        setLoginMode('tutor-first');
        setFirstLoginData(prev => ({ ...prev, email: userData.email, name: userData.name, tempPassword: formData.password }));
        setEmailVerified(true);
        setForcePasswordChange(true);
        setLoading(false);
        return;
      }

      // 정상 로그인
      onLogin(userData);
    } catch (err) {
      setError(err.message || '로그인에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };





  return (
    <div className="login-container">
      <div className="login-card">
        <div className="logo-container">
          <img 
            src="/images/coderland_icon.png" 
            alt="코더랜드 로고" 
            className="logo"
            onError={(e) => {e.target.style.display = 'none'}}
          />
        </div>
        <p className="login-subtitle">튜터 스케줄 관리 시스템</p>
        
        <form onSubmit={handleSubmit} className="login-form">
          {!isFirstLogin ? (
            // 일반 로그인 폼
            <>
              <div className="form-group">
                <label htmlFor="email">코더랜드 이메일</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@elicer.com"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password">비밀번호</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="비밀번호를 입력하세요"
                  required
                />
              </div>
            </>
          ) : (
            // 최초 로그인 폼
            <>
                             <div className="form-group">
                 <label htmlFor="email">코더랜드 이메일</label>
                 <div className="email-verification-container">
                   <input
                     type="email"
                     id="email"
                     name="email"
                     value={firstLoginData.email}
                     onChange={handleFirstLoginChange}
                     placeholder={
                       loginMode === 'admin-first' 
                         ? 'admin@elicer.com' 
                         : '코더랜드 가입 계정 이메일을 입력하세요'
                     }
                     required
                     disabled={emailVerified}
                     className={emailVerified ? 'verified' : ''}
                   />
                   {loginMode === 'tutor-first' && (
                     <button
                       type="button"
                       className={`verify-btn ${emailVerified ? 'verified' : ''}`}
                       onClick={handleEmailVerification}
                       disabled={verifyingEmail || emailVerified || !firstLoginData.email.trim()}
                     >
                       {verifyingEmail ? '인증 중...' : emailVerified ? '✓ 인증완료' : '인증'}
                     </button>
                   )}
                 </div>
               </div>
               
               <div className="form-group">
                 <label htmlFor="name">이름</label>
                 <input
                   type="text"
                   id="name"
                   name="name"
                   value={firstLoginData.name}
                   onChange={handleFirstLoginChange}
                   placeholder={
                     loginMode === 'admin-first' 
                       ? "이름을 입력해주세요" 
                       : emailVerified 
                         ? "이름이 자동으로 입력되었습니다" 
                         : "이메일 인증 후 자동 입력됩니다"
                   }
                   required
                   disabled={emailVerified}
                   className={emailVerified ? 'auto-filled' : ''}
                 />
               </div>
              
                             {/* 아이디 제거: 이메일로 로그인 */}
              
              <div className="form-group">
                <label htmlFor="password">비밀번호</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={firstLoginData.password}
                  onChange={handleFirstLoginChange}
                  placeholder="사용할 비밀번호를 입력하세요"
                  required
                />
              </div>
              
                             {loginMode === 'admin-first' && (
                 <div className="form-group">
                   <label htmlFor="inviteCode">초대코드</label>
                   <input
                     type="text"
                     id="inviteCode"
                     name="inviteCode"
                     value={firstLoginData.inviteCode}
                     onChange={handleFirstLoginChange}
                     placeholder="관리자에게 받은 초대코드를 입력하세요"
                     required
                   />
                 </div>
               )}
            </>
          )}
          
          {error && <div className="error-message">{error}</div>}
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading 
              ? '처리 중...' 
              : isFirstLogin 
                ? (forcePasswordChange ? '비밀번호 변경' : (loginMode === 'admin-first' ? '관리자 계정 생성' : '튜터 계정 생성'))
                : '로그인'
            }
          </button>
        </form>

        {/* 최초 로그인 선택: 튜터 버튼 제거 (임시비번 로그인 시 자동전환) */}
        {!isFirstLogin && (
          <div className="first-login-section">
            <div className="divider">
              <span>또는</span>
            </div>
            <div className="first-login-options">
              <button
                type="button"
                className="first-login-btn admin-btn"
                onClick={() => {
                  setIsFirstLogin(true);
                  setLoginMode('admin-first');
                }}
              >
                👨‍💼 관리자 최초 로그인
              </button>
            </div>
          </div>
        )}

        {/* 최초 로그인 모드에서 뒤로가기 */}
        {isFirstLogin && (
          <div className="back-to-login">
            <button
              type="button"
              className="back-btn"
                             onClick={() => {
                 setIsFirstLogin(false);
                 setLoginMode('normal');
                 setFirstLoginData({ email: '', name: '', tempPassword: '', password: '', inviteCode: '' });
                 setFormData({ email: '', password: '' });
                 setError('');
                 setEmailVerified(false);
                 setVerifyingEmail(false);
               }}
            >
              ← 일반 로그인으로 돌아가기
            </button>
          </div>
        )}
      </div>
      



    </div>
  );
};

export default Login; 